module.exports = __webpack_public_path__ + "img/refresh.cbd924d6.png";